import { Component, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { Router, Route } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
// import { DataService } from 'src/app/data-service/data.service';
// // import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']


})
export class HeaderComponent implements OnInit {

  roleName: any;
  role: any;
  name: any;
  modalRef: BsModalRef;
  navbarOpen = false;
  is_emeter:any;
  is_wms:any;
  // lastUpdatedAt:any;
  // lastUpdatedAt$!: Observable<any>;
  // constructor( private router: Router,private modalDialogService: ModalDialogService, private viewContainer: ViewContainerRef ,public toastr: ToastrService) { }
  constructor(private modalDialogService: ModalModule, private viewContainer: ViewContainerRef, private modalService: BsModalService, private toastr: ToastrService, private router: Router) {

    this.role = localStorage.role;
    this.name = localStorage.name;
    this.is_emeter = localStorage.getItem('is_emeter');
    this.is_wms = localStorage.getItem('is_wms');

    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }
    else if (this.role == '3') {
      this.roleName = 'wms';
    }
    else if (this.role == '4') {
      this.roleName = 'normal';
    }
    else if(this.role == '5'){
      this.roleName = 'slave_admin'
    }
    else if(this.role == '6'){
      this.roleName = 'ze'
    }
    else if(this.role == '7'){
      this.roleName = 'dg'
    }
  }

  ngOnInit() {

    // this.dataService.lastUpdatedAt.subscribe(data=>{
    //   this.lastUpdatedAt = data;
    // })
      // this.lastUpdatedAt$ = this.dataService.lastUpdatedAt;
  }
  toggleNavbar() {

    this.navbarOpen = !this.navbarOpen;
  }
  openMessage() {
    this.toastr.success("Log Out Successfully");
    localStorage.clear();
  }

}
